import React from "react";
import { Select } from "components/form-component/select/select";
import { Input } from "components/form-component/input/input";
import {
  Dashed,
  FormStyles,
  DataHeading,
  DataStyles,
  WrapperWidth,
  FlexGrowWrapper,
  SpaceWrapper,
  ButtonCTA,
  AlertWrapper,
  FormWrapper
} from "./user-profile-form.styles";
import { userTypes, nameTitles } from "constants/constants";
import { IUserProfileFormWithMixpanel } from "./use-profile-form.types";
import { Label } from "components/form-component/label/label";
import { useParentForm } from "./hooks/use-parent-form";
import { Checkbox } from "components/atoms/checkbox/checkbox";
import { VerifiedInput } from "components/form-component/verified-input/verified-input";
import { monetisationClassOptions } from "constants/constants";
import { MobileInput } from "components/form-component/mobile-input/mobile-input";
import { Alert } from "components/atoms/alert/alert";

const ParentForm = ({
  userType,
  defaultGrade,
  summaryPackageData
}: IUserProfileFormWithMixpanel): JSX.Element => {
  const {
    control,
    handleSubmit,
    handleCheckbox,
    isValid,
    onSubmit,
    getPhoneNumberFromRegisterToken,
    isLoading
  } = useParentForm(userType, summaryPackageData, defaultGrade);

  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <VerifiedInput
        label="Nomor HP"
        defaultValue={getPhoneNumberFromRegisterToken}
        name="verifiedInput"
      />
      <FormStyles>
        <WrapperWidth width="20%">
          <Select
            name="userType"
            control={control}
            label="Saya Adalah"
            options={userTypes}
          />
        </WrapperWidth>

        <DataStyles>
          <WrapperWidth width="25%">
            <Select
              data-testid="salutation-dropdown"
              name="salutation"
              control={control}
              label="Nama Orangtua"
              options={nameTitles}
            />
          </WrapperWidth>

          <FlexGrowWrapper>
            <Input
              data-testid="full-name-field"
              control={control}
              name="fullName"
              placeholder="isi nama orangtuamu di sini"
            />
          </FlexGrowWrapper>
        </DataStyles>
      </FormStyles>
      <Dashed />
      <DataHeading>Data Murid</DataHeading>
      <Label id="nomor-hp">Nomor HP murid</Label>
      <Checkbox
        testId="is-parent-check-field"
        onChange={handleCheckbox}
        control={control}
        name="isParent"
        label="Pakai nomor HP saya"
      />

      <MobileInput
        label="Nomor HP"
        placeholder="Ketik nomor HP murid di sini"
        control={control}
        name="studentNumber"
      />

      <AlertWrapper>
        <Alert
          variant="info"
          alertText="Paket belajar akan diaktifkan di nomor ini."
        />
      </AlertWrapper>

      <DataStyles>
        <WrapperWidth width="70%">
          <Input
            data-testid="student-name-field"
            name="studentName"
            label="Nama Murid"
            control={control}
            placeholder="Ketik nama murid di sini"
          />
        </WrapperWidth>

        <FlexGrowWrapper>
          <Select
            data-testid="grade-dropdown"
            name="grade"
            control={control}
            label="Kelas"
            options={monetisationClassOptions}
            placeholder="Pilih kelas"
          />
        </FlexGrowWrapper>
      </DataStyles>
      <Input
        data-testid="email-field"
        name="email"
        label="Email"
        control={control}
        placeholder="Ketik alamat email di sini"
      />

      <SpaceWrapper>
        <ButtonCTA
          disabled={!isValid}
          type="submit"
          variant="primary"
          isLoading={isLoading}
          loadingText={"Membuat profil"}
          data-testid="register-profile-button">
          Buat profil
        </ButtonCTA>
      </SpaceWrapper>
    </FormWrapper>
  );
};

export { ParentForm };
